import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

// Renders a Route that redirects view-only users to `redirectTo`.
// Use for add / edit routes (e.g. /fillups/addnew) so a view-only user
// cannot reach the form via direct URL entry.
const WriteRoute = ({ redirectTo, component, render, children, ...routeProps }) => {
  const { isViewOnly } = useAuth();
  if (isViewOnly) {
    return <Route {...routeProps} render={() => <Redirect to={redirectTo} />} />;
  }
  return <Route {...routeProps} component={component} render={render}>{children}</Route>;
};

export default WriteRoute;
